<template>
  <OnboardingLayout>
    <main class="email-verification">
      <img src="@/assets/icons/email.svg" alt="email" />
      <h1 class="email-verification__heading heading">{{ $t('emailVerification.heading') }}</h1>
      <p class="email-verification__message">{{ $t('emailVerification.message') }}</p>
      <span class="register__resend">
        {{ $t('emailVerification.resend') }}
        <Button @click="handleClick" :loading="loading" simple>
          {{ $t('emailVerification.buttons.resendEmail') }}
        </Button>
      </span>
    </main>
  </OnboardingLayout>
</template>

<script>
import api from '@/api';
import { Button } from '@/components/common';
import { OnboardingLayout } from '@/components/layouts';

export default {
  name: 'EmailVerificationView',
  components: { Button, OnboardingLayout },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async handleClick() {
      try {
        this.loading = true;
        await api.auth.sendEmailVerification();
        this.$notifications.success(this.$t('emailVerification.resendSuccessMessage'));
      } catch (error) {
        this.$notifications.error(error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
  .email-verification {
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 35px 0 100px;

    @include md-up {
      padding: 0;
    }

    img {
      margin-bottom: 64px;
      transform: translateX(15px);
    }

    &__heading {
      font-size: 20px;
      font-weight: 600;
      letter-spacing: .21px;
      margin-bottom: 32px;

      @include md-up {
        font-size: 28px;
        letter-spacing: .3px;
        margin-bottom: 20px;
      }
    }

    &__message {
      color: $secondary;
      font-size: 14px;
      line-height: 1.57;
      margin: 0 15px 48px 15px;
      text-align: center;

      @include md-up {
        margin-bottom: 64px;
      }
    }

    &__resend {
      font-size: 14px;
      letter-spacing: .2px;
      line-height: 1.43;
    }
  }
</style>
